import { PayloadActionData } from 'models';

export const GET_BASE_REQUEST_REQUEST = 'GET_BASE_REQUEST_REQUEST';

export const getBaseRequestAction = (
  payload: PayloadActionData<{ accessToken?: string }>,
) => ({
  type: GET_BASE_REQUEST_REQUEST,
  payload,
});
